// The code in this file will load on every page of your site

$w.onReady(function () {
	//<meta name="google-adsense-account" content="ca-pub-1435155875421416">
});